import "./styles/styles.scss";

import React from "react";
import ReactDOM from "react-dom/client";
import {RouterProvider} from "react-router-dom";

import {GlobalContextProvider} from "./context/global.tsx";
import {router} from "./router/router.tsx";

router.then(allRoute => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <GlobalContextProvider>
        <RouterProvider router={allRoute} />
      </GlobalContextProvider>
    </React.StrictMode>,
  );
});
